// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"152":"f9fcffa2","569":"4797edc0"}[chunkId] + ".js";
};